__webpack_require__.p = "/study-react-beautiful-dnd-atlassian/";